













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class CustomChoiceElement extends Vue {
  @Prop(Boolean) private readonly value!: boolean;
}
